<template>
<div>

    <div class="news-categories w-100 mt-4 mt-md-6 mb-6">
        <div class="btn btn-sm btn-secondary mr-1 mb-2"
        v-bind:class="{'btn-success': isCategoryActive()}"
        v-on:click="toggleCategory()">
            Alla
        </div>
        <div class="btn btn-sm btn-secondary mr-2 mb-2"
            v-for="category in categories"
            v-bind:class="{ 'btn-success': isCategoryActive(category.term_id) }"
            v-on:click="toggleCategory(category.term_id)">
            {{ category.name }}
        </div>
    </div>

    <div class="row">
        <div class="col-12 col-sm-6 col-lg-4 mb-4 mb-sm-6" v-for="post in limitedPosts">

            <a v-bind:href="post.link" style="text-decoration: none;" class="text-white">
                <div class="news-grid-element">

                    <img v-bind:src="post.img">

                    <div class="overlay">
                        <div class="overlay-content">
                            <h5 class="text-white">{{ post.date }}</h5>
                            <h2 class="text-white">{{ post.post_title }}</h2>
                        </div>
                    </div>

                </div>
            </a>

        </div>
    </div>

    <div v-if="totalPosts > query.limit" style="cursor: pointer; font-weight: bold;" class="w-100 bg-black text-center text-white p-4"
        v-on:click="query.limit += numPosts">
        Visa fler
    </div>

</div>
</template>

<script>

    export default {

        props: {
            categories: {
                require: true,
            },
            posts: {
                require: true,
            }
        },

        data ()
        {
            return {
                active: 'active',
                query: {
                    categories: [],
                    limit: 9,
                },
                totalPosts: this.posts.length
            }
        },

        computed: {

            filteredPosts() {

                if(this.query.categories.length == 0) {
                    return this.posts
                }

                var filtered = _.filter(this.posts, (post) => {
                    for (var i = 0; i < post.categories.length; i++) {
                        if (this.query.categories.indexOf(post.categories[i]) !== -1) {
                            return true
                        }
                    }
                })

                // return _.orderBy(filtered, ['sort_id'], ['asc']);
                return filtered;
            },

            limitedPosts() {
                return _.take(this.filteredPosts, this.query.limit);
            },

            numPosts() {
                var postsToLoad = 9;
                var diffNumPosts = this.totalPosts - this.query.limit;

                if (diffNumPosts <= postsToLoad) {
                    return diffNumPosts;
                }

                return postsToLoad;
            }


        },

        methods: {

            isCategoryActive(category) {
                if (!category && this.query.categories.length == 0) {
                    return true;
                }

                return this.query.categories.indexOf(category) !== -1
            },

            toggleCategory(category) {
                if (!category) {
                    return  this.query.categories = []
                }

                var index = this.query.categories.indexOf(category)

                if(index !== -1) {
                    this.query.categories.splice(index, 1)
                    return
                }

                this.query.categories.push(category)

            }

        }

    }

</script>



// WEBPACK FOOTER //
// assets/js/vue/news.vue